import angular from 'angular';
import { IDetalhamentoErro } from '../../../models/escala.erros.model';

export class MeurhEscalaErrosImportacaoModalService {
  static $inject = ['$uibModal'];

  constructor(public $uibModal: ng.ui.bootstrap.IModalService) {
  }

  open(entity: IDetalhamentoErro[], tipoImportacao: string) {
    return this.$uibModal.open({
      template: require('html-loader!./erros.modal.html'),
      controller: 'MeurhEscalaErrosImportacaoModalController',
      controllerAs: 'mrh_scl_rrs_mdl_cntrllr',
      windowClass: 'nsj-modal-lg-no-height',
      resolve: {
        entity: () => angular.copy(entity),
        tipoImportacao: () => tipoImportacao
      }
    });
  }
}
